export class QueryDisabledError extends Error {
	constructor() {
		super('QueryDisabledError');
	}
}
